import { EventEmitter, ComponentRef, Injectable } from '@angular/core';
import { HttpClient, HttpRequest, HttpHeaders, HttpResponse,HttpErrorResponse } from '@angular/common/http';
import { UploadFile } from 'ng-zorro-antd';
import { ObjectUtils } from '@ark-libs/ngx-utils';
import { filter, map } from 'rxjs/operators';
import { Observable } from 'rxjs';
import { CoreConfigService } from '../config/core-config.service';
import { AppSettingService } from '../service/app-setting.service';
import { AuthServerProvider } from '../auth/auth-jwt.service';

@Injectable({ providedIn:'root' })
export class UploadPhotoHelper {
    constructor(
		private http: HttpClient,
        private configService: CoreConfigService,
        private appSettings: AppSettingService,
        private authServerProvider: AuthServerProvider,
    ) { }

	convertBase64UrlToBlob(base64Data){  
	    const bytes=window.atob(base64Data.split(',')[1]);        //去掉url的头，并转换为byte  
	      
	    //处理异常,将ascii码小于0的转换为大于0  
	    const ab = new ArrayBuffer(bytes.length);  
	    const ia = new Uint8Array(ab);  
	    for (var i = 0; i < bytes.length; i++) {  
	        ia[i] = bytes.charCodeAt(i);  
	    }
	    return new Blob( [ab] , {type : this.parseBase64DataFileContentType(base64Data)});  
	}
	parseBase64DataFileContentType(base64Data){
		return base64Data.substring(base64Data.indexOf("data:")+5, base64Data.indexOf(";base64"));
	}
	parseBase64DataFileExt(base64Data){
		const contentType = this.parseBase64DataFileContentType(base64Data);
		return contentType.substring(contentType.indexOf("/")+1);
	}

    get uploadUrl():string {
        return this.configService.apiUrls.uploadFile;
	}
	get photoBaseUrl():string {
        return this.appSettings.photoBaseUrl;
    }

	get uploadHeaders() {
		const token = this.authServerProvider.getToken();
        if (token && token.length > 0){
			return {'Authorization': 'Bearer ' + this.authServerProvider.getToken()};
		}
		return null;
	}

	resolveFileUploadResponse(file:any){
		// console.log("resolveFileUploadResponse", file);
		const err = file.error;
		if(err&&err.status==200&&err.error&&err.error.text){
			// 从返回的html中分析MD5
			const html = err.error.text;
			const photoMd5 = html.match(/[\u4e00-\u9fa5_a-zA-Z0-9\<\>\/ :]+/g)
				.filter(item=>item.indexOf("<h1>MD5:")!=-1)
				.map(text=>text.substring(9,41)).pop();

			if(photoMd5){
				file.response = { ret: true, info:{md5: photoMd5, size: file.size } };
				file.message = undefined;
				file.error = undefined;
				file.status = "done";
			}
		}else if(file.body){
			file.response = file.body;
		}
	}

	parseUploadEvent(event): {md5:string, url:string}[] {
		const fileList: UploadFile[] = event.fileList?[...event.fileList]:[];
		if(event.file&&fileList.length==0)fileList.push(event.file);

		const result = [];
		if(fileList.length == 0) return result;

		fileList.forEach(file=>{
			result.push(this.parseUploadFile(file));
		});
	}
	
	parseUploadFile(file:UploadFile): {md5?:string, url?:string} {
		// 此方法处理返回信息的分析，并md5结果写入file对象中
		if(file==null||file.status!='done'||file.percent!=100) return {};

		this.resolveFileUploadResponse(file);

		if(file.response&&file.response.info.md5){
			let md5 = file.response.info.md5;
			file.uploadResult = { 
				md5: md5,
				url: (md5?this.photoBaseUrl+md5:undefined)
			};
			return file.uploadResult;
		}
	}

	handleChange(event:any, doneCallback:Function, progressCallback:Function){
		if(event == null) return;
		
		if(event.percent == 100){
			if(doneCallback) doneCallback(event);
		}else{
			if(progressCallback) progressCallback(event);
		}
	}

	md5ToUrl(md5: string){
		return md5 ? `${this.photoBaseUrl}${md5}`:md5;
	}

	resolvePhotoUrl(photoValue: string){
		if(photoValue == null) return "";
		
		return photoValue&&(photoValue.indexOf("http")==0||photoValue.indexOf("data:")==0)
				? photoValue : this.md5ToUrl(photoValue);
	}

	uploadBase64Data(base64Data: string): Promise<any>{
		if(!base64Data) return null;

	    const formData = new FormData();
		formData.append('files[]', this.convertBase64UrlToBlob(base64Data), "file."+this.parseBase64DataFileExt(base64Data));
		
	    const req = new HttpRequest('POST', this.uploadUrl, formData, {
			headers: new HttpHeaders(this.uploadHeaders),
	        reportProgress: true
	    });

		return this.http.request(req)
			.pipe(filter(e => e instanceof HttpResponse || e instanceof HttpErrorResponse))
			.toPromise()
			.then(event=>{
				event["percent"] = 100;
				event["fileType"] = this.parseBase64DataFileContentType(base64Data);
				this.parseUploadEvent({file:event});
				// console.log("then->", event);
				return event;
			})
			.catch(error=>{
				const file = { 
					percent:100, 
					fileType:this.parseBase64DataFileContentType(base64Data), 
					error:error
				};
				this.parseUploadEvent({file:file});
				// console.log("catch->", file);
				return file;
			});
	}
}
